import React from 'react';
import '../App.css';

const Marker = (props) => {
    const { color, id } = props;
    return (
      <div className="marker"
          key={id}
        style={{ backgroundColor: color, cursor: 'pointer', opacity:0.2}}
        
      />
    );
  };
export default Marker;